import { useI18n } from '../context/I18nContext';
import Seo from '../components/Seo';
import AboutHeroSection from '../components/about-page/AboutHeroSection';
import AboutOfferSection from '../components/about-page/AboutOfferSection';
import AboutReputationSection from '../components/about-page/AboutReputationSection';
import AboutShortcutsSection from '../components/about-page/AboutShortcutsSection';
import AboutTeamSection from '../components/about-page/AboutTeamSection';
import AboutVideoBannerSection from '../components/about-page/AboutVideoBannerSection';

const dbConnect = require('../lib/mongodb');
const TeamMember = require('../models/TeamMember');
const {
  DEFAULT_TEAM_MEMBERS,
  applyTeamMemberOrder,
  serializeTeamMember,
  sortTeamMembers,
} = require('../lib/teamMembers');

export default function AboutPage({ teamMembers }) {
  const { language } = useI18n();
  const title = language === 'fr' ? "À propos d'ETC Company" : 'About ETC Company';
  const description =
    language === 'fr'
      ? 'Découvrez l’histoire, l’équipe, la réputation et l’offre d’ETC Company en Tunisie.'
      : 'Discover ETC Company’s story, team, reputation, and offer in Tunisia.';

  return (
    <div key={language}>
      <Seo
        title={title}
        description={description}
        keywords={{
          en: ['about ETC Company', 'company profile', 'warehouse equipment supplier', 'spare parts', 'Tunisia'],
          fr: ['à propos ETC Company', 'profil entreprise', 'fournisseur de matériel de manutention', 'pièces de rechange', 'Tunisie'],
        }}
      />
      <AboutHeroSection />
      <AboutVideoBannerSection />
      <AboutOfferSection />
      <AboutReputationSection />
      <AboutTeamSection teamMembers={teamMembers} />
      <AboutShortcutsSection />
    </div>
  );
}

export async function getStaticProps() {
  try {
    await dbConnect();
    const items = await TeamMember.find({ deletedAt: null }).sort({ sortOrder: 1, createdAt: 1 }).lean();
    const { getSignedCloudinaryUrl } = require('../lib/cloudinary');
    const serialized = (Array.isArray(items) ? items : [])
      .map(serializeTeamMember)
      .filter(Boolean)
      .map((member) => ({
        ...member,
        imageUrl: getSignedCloudinaryUrl(member.imageUrl || '') || member.imageUrl || '',
      }));
    return {
      props: {
        teamMembers: serialized.length > 0 ? applyTeamMemberOrder(sortTeamMembers(serialized)) : DEFAULT_TEAM_MEMBERS,
      },
      revalidate: 300,
    };
  } catch (err) {
    return {
      props: {
        teamMembers: DEFAULT_TEAM_MEMBERS,
      },
      revalidate: 300,
    };
  }
}
